<div class="container-fluid" >
  <div class="d-flex align-items-center justify-content-between flex-wrap" *ngIf="template">
    <div class="start d-flex align-items-center flex-wrap">
      <button nbButton size="tiny" status="basic" class="btn" [routerLink]="['/pages/template/'+template?.id+'/edit']">
        <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
      </button>
      <div>
        <h1 class="my-0">{{ template?.name | txtTranslate }}</h1>
      </div>
    </div>
    <div class=" end">
      <template-menu [template]="template"></template-menu>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between flex-wrap" *ngIf="!template">
    <div class="start d-flex align-items-center flex-wrap">
      <button nbButton size="tiny" status="basic" class="btn" [routerLink]="['/pages/game/'+game?.id+'/edit-missions']">
        <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
      </button>
      <div>
        <h1 class="my-0">{{ game?.name | txtTranslate }}</h1>
      </div>
    </div>
    <div class="end">
      <game-menu [game]="game"></game-menu>
    </div>
  </div>
</div>

<div class="accordion-container col">
  <nb-card *ngIf="game?.type !== 'poi_list'" size="giant" accent="info">
    <nb-card-header>
      <div class="d-flex align-items-center justify-content-between w-100">
        <span>Objects</span>
      </div>
      <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="template" (click)="applyChanges()">
        <nb-icon icon="code-download-outline" pack="eva"></nb-icon>Apply changes for {{typeLabelSelected}}
      </button>
    </nb-card-header>
    <nb-card-body style="padding-top: 0 !important; padding-left: 0 !important;">
      <nb-tabset fullWidth (changeTab)="changeTab($event)" >
        <nb-tab *ngFor="let type of objectTypes; let i = index" active={{type.active}} [tabId]="type.id" [tabTitle]="type.label | txtTranslate"
          [badgeText]="getObjectCount(type.id)" badgePosition="top right" badgeStatus="success">
          <table class="table table-hover">
            <thead>
              <tr>
                <td>Order</td>
                <td>Icon</td>
                <td>Label</td>
                <td class="text-right"><button type="button" class="btn btn-success" *ngIf="type.id != 'All'" (click)="editObject(null, type)">Add new '{{ type.label | txtTranslate }}'</button></td>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-object="$implicit" [ngForOf]="objects">
                <tr *ngIf="object.objectTypeId == type.id">
                  <td>{{object.orderNum}}</td>
                  <td>
                    <img [src]="object | objectImage" style="width:40px;height:auto;">
                  </td>
                  <td >{{ object.labels | txtTranslate }}</td>
                  <td class="text-right">
                    <button nbButton class="btn-rounded ml-3" status="info" [disabled]="typeObjects[object.objectTypeId].length === object.orderNum" outline (click)="changePosition(object.orderNum, object.orderNum+1, object)">
                      <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
                    </button>
                    <button nbButton class="btn-rounded ml-3" status="info" [disabled]="object.orderNum === 1" outline (click)="changePosition(object.orderNum, object.orderNum-1, object)">
                      <nb-icon icon="arrow-ios-upward-outline"></nb-icon>
                    </button>
                    <button class="btn btn-rounded btn-xs btn-info btn-inverse ml-3"
                      (click)="editObject(object,null)">EDIT</button>
                    <button class="btn btn-rounded btn-xs btn-danger btn-inverse ml-3"
                      (click)="deleteObject(object)"><nb-icon icon="trash-2-outline"></nb-icon></button>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </nb-tab>
      </nb-tabset>
    </nb-card-body>
  </nb-card>
</div>